<div class="form-group" [formGroup]="formGroup" *ngIf="formGroup">
    <!-- Campo oculto para armazenar o valor selecionado -->
    <input type="hidden" [id]="controlName" [formControlName]="controlName" />

    <!-- Label do campo -->
    <label [for]="controlName" class="form-control-label">
        {{ label ?? 'Campo sem label definida' }}
        <span class="text-danger" *ngIf="isRequired">*</span>
    </label>

    <!-- Campo de busca -->
    <input
        type="text"
        class="form-control"
        [formControl]="searchControl"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        #instance="ngbTypeahead"
        [ngClass]="{
            'is-invalid':
                formControl.invalid &&
                (formControl.dirty || formControl.touched || changeText)
        }"
        (selectItem)="updateHiddenInput($event.item)"
        [placeholder]="searchControl.disabled ? '' : 'Digite para buscar...'" />

    <!-- Mensagens de erro -->
    <div class="invalid-feedback" *ngIf="formControl.errors?.required">
        Este campo é obrigatório
    </div>
    <div
        class="invalid-feedback"
        *ngIf="formControl.errors && !formControl.errors?.required">
        Campo inválido
    </div>

    <!-- Mensagens de validação -->
    <div class="text-danger small mt-1" *ngIf="!formGroup">
        <i class="fas fa-exclamation-triangle"></i>
        FormGroup não definido
    </div>
    <div class="text-danger small mt-1" *ngIf="!formControl">
        <i class="fas fa-exclamation-triangle"></i>
        FormControl não definido
    </div>
    <div class="text-danger small mt-1" *ngIf="!itemValueName">
        <i class="fas fa-exclamation-triangle"></i>
        itemValueName não definido
    </div>
    <div class="text-danger small mt-1" *ngIf="!itemKeyName">
        <i class="fas fa-exclamation-triangle"></i>
        itemKeyName não definido
    </div>

    <!-- Mensagem de carregamento -->
    <div class="text-info small mt-1" *ngIf="!formControl?.disabled && !items">
        <i class="fas fa-spinner fa-spin"></i>
        Carregando dados...
    </div>
</div>
